export const staircaseConfig = {
    gameSlug: 'freeze-frame',
    category: 'feu_vivacite',
    variable: 'duration_ms',
    startValue: 700,
    minValue: 250,
    maxValue: 1500,
    stepSizesByPhase: [100, 50, 30, 20],
    reversalsToConverge: 4,
    reversalsForThreshold: 3,
    // MVP : 24 essais max, < 3 min test live.
    maxTrials: 24,
    direction: 'down-easier',
};
function buildVariant(level) {
    if (level <= 10) {
        return { level, nogoRatio: 0.3, goGlyph: 'X', nogoGlyph: 'Y', label: 'Frein simple' };
    }
    if (level <= 20) {
        return { level, nogoRatio: 0.25, goGlyph: 'X', nogoGlyph: 'Y', label: 'Frein vif' };
    }
    if (level <= 30) {
        return { level, nogoRatio: 0.18, goGlyph: 'X', nogoGlyph: 'O', label: 'NoGo rare' };
    }
    if (level <= 40) {
        return { level, nogoRatio: 0.15, goGlyph: '◆', nogoGlyph: '●', label: 'Glyphes alternatifs' };
    }
    return { level, nogoRatio: 0.12, goGlyph: '▲', nogoGlyph: '◯', label: 'Inhibition limite' };
}
export const levels = Array.from({ length: 50 }, (_, i) => buildVariant(i + 1));
export function variantForLevel(level) {
    const idx = Math.max(1, Math.min(50, level)) - 1;
    return levels[idx];
}
/** Durées non-staircase. */
export const timing = {
    fixationMs: 400,
    feedbackMs: 500,
    itiMs: 600,
    /** Buffer après extinction du glyph durant lequel un tap reste accepté. */
    awaitingResponseMs: 600,
};
export const paradigmMeta = {
    slug: 'freeze-frame',
    paradigm: 'Go/NoGo inhibition (Verbruggen & Logan 2008)',
    masterMage: 'Inori (air-attention)',
    category: 'air_attention',
    goal: 'Inhibition rapide : conduite, sport, prise de décision sous pression.',
};
//# sourceMappingURL=params.js.map